import {
    BuildDistroBuildSharedWithMe,
    BuildDistroWorkItemsByBuild,
    BuildDistroFilterByVCSUsersBehaviorType,
} from '../types';
import { BuildDistroReducerType } from './../reducers/buildDistribution';

// Not gonna lie, this was a gem I created thanks to GPT-4
//
// Update: 21/06/2023, I fixed this to allow for arrays of enums and it works perfectly,
// updating the score...
// AI: 1 - Humans: 1
//
// I asked GPT-4 to generate a recursive type that turns enums into plain strings
// with a bit of tweaking, I got this. This is perfect for our demo objects, now we can copy
// and paste the demo data from actual live instances without having to turn enums into Typescript values
// while we still get the benefits of type checking. So any changes in the type will
// create a compile error in the demo data. This actually helped me find inconsistencies in our BE data and the FE types
// so I'm pretty happy with this.
//
// support for arrays of enums
export type RecursiveStringifyEnums<T> =
    T extends string ? `${T}`
    :   {
            [P in keyof T]: T[P] extends (infer U)[] ? RecursiveStringifyEnums<U>[]
            : T[P] extends object ? RecursiveStringifyEnums<T[P]>
            : T[P] extends string ? `${T[P]}`
            : T[P];
        };

export const generateWorkItems = (): RecursiveStringifyEnums<BuildDistroWorkItemsByBuild[]> => {
    return [
        {
            ciBuildIdentifier: '3941',
            ciIntegrationId: 'bitrise',
            binaryBuildIdentifier: '3941',
            uploadedAt: '2023-06-06T20:21:50Z',
            items: [
                {
                    id: '',
                    ticket: null,
                    code: {
                        author: 'amelia',
                        branch: 'development',
                        committedAt: '2023-06-20T16:02:38Z',
                        identifier: '375004c',
                        message:
                            'Merge pull request #184 from demo/ale/test_cherry_pick_for_notification_only\n\n[runway:fix-3.103.0] Readme change',
                        status: 'merged',
                        type: 'commit',
                        url: 'https://github.com/demo/-ios/commit/375004c7bb420757292d4fb20b527bd07511ff0d',
                        manualCherryPickCommands: [],
                        manualCherryPickContext: null,
                        sourcePR: null,
                    },
                    explanationText:
                        'This code exists in the diff for the release; no ticket is referenced by this code',
                    ignored: false,
                    autoIgnored: false,
                    isItemDone: true,
                    isInLatestOrSelectedStagingBuild: false,
                    isInLatestWorkingBranchBuild: false,
                    associatedStabilityIssues: [],
                    debugVariant: 'codeMergedNoTicket',
                },
                {
                    id: '',
                    ticket: null,
                    code: {
                        author: 'amelia',
                        branch: 'development',
                        committedAt: '2023-06-20T16:01:44Z',
                        identifier: 'c79de8d',
                        message: 'Readme change',
                        status: 'merged',
                        type: 'commit',
                        url: 'https://github.com/demo/-ios/commit/c79de8dd740558f6d43aa9c554728dc10aab8215',
                        manualCherryPickCommands: [],
                        manualCherryPickContext: null,
                        sourcePR: null,
                    },
                    explanationText:
                        'This code exists in the diff for the release; no ticket is referenced by this code',
                    ignored: false,
                    autoIgnored: false,
                    isItemDone: true,
                    isInLatestOrSelectedStagingBuild: false,
                    isInLatestWorkingBranchBuild: false,
                    associatedStabilityIssues: [],
                    debugVariant: 'codeMergedNoTicket',
                },
                {
                    id: '',
                    ticket: null,
                    code: {
                        author: 'runway-github[bot]',
                        branch: 'development',
                        committedAt: '2023-06-02T23:00:29Z',
                        identifier: '9854563',
                        message:
                            '[TAB-PREFIX] Bumping version to 3.105.0 (#182)\n\nRunway bumped your version to 3.105.0 <Tab PR Body>',
                        status: 'merged',
                        type: 'commit',
                        url: 'https://github.com/demo/-ios/commit/9854563cace25b2ce2415317000282e6b939f88d',
                        manualCherryPickCommands: [],
                        manualCherryPickContext: null,
                        sourcePR: null,
                    },
                    explanationText:
                        'This code exists in the diff for the release; no ticket is referenced by this code',
                    ignored: false,
                    autoIgnored: false,
                    isItemDone: true,
                    isInLatestOrSelectedStagingBuild: false,
                    isInLatestWorkingBranchBuild: false,
                    associatedStabilityIssues: [],
                    debugVariant: 'codeMergedNoTicket',
                },
            ],
        },
        {
            ciBuildIdentifier: '3801',
            ciIntegrationId: 'bitrise',
            binaryBuildIdentifier: '3801',
            uploadedAt: '2023-06-06T18:59:30Z',
            items: [
                {
                    id: '',
                    ticket: {
                        identifier: 'APPOLLO-29',
                        description: 'Update readme for account deletion',
                        fullDescription: null,
                        url: 'https://demo.atlassian.net/browse/APPOLLO-29',
                        owner: 'Amelia',
                        reporter: 'Amelia',
                        status: 'Done',
                        createdAt: '2023-05-25T10:46:58.376-06:00',
                        updatedAt: '2023-06-22T10:40:42.623-06:00',
                        isTicketMissingFeatureAffiliation: false,
                        isTicketSubtask: false,
                        isTicketDone: true,
                        project: {
                            identifier: 'TAB',
                            displayableName: 'Tab',
                            url: 'https://demo.atlassian.net/browse/TAB',
                        },
                        featureAffiliations: [
                            {
                                resolvedString: 'ios-3.103.0',
                                integrationId: 'jira',
                                affiliationType: 'jira-fix-version',
                            },
                        ],
                        additionalFields: {},
                    },
                    code: {
                        author: 'gsavit',
                        branch: 'development',
                        committedAt: '2023-05-25T16:50:22Z',
                        identifier: '4816c05',
                        message:
                            'Merge pull request #178 from demo/gs-readme-update\n\nAPPOLLO-29 update readme for deletion [runway:fix-3.103.0]',
                        status: 'merged',
                        type: 'commit',
                        url: 'https://github.com/demo/-ios/commit/4816c05c9f75b8948103d64910335fce0d88aee7',
                        manualCherryPickCommands: [],
                        manualCherryPickContext: null,
                        sourcePR: null,
                    },
                    explanationText:
                        'This code exists in the diff for the release, and it references this ticket in its commit message, former PR title, or former branch name',
                    ignored: false,
                    autoIgnored: false,
                    isItemDone: true,
                    isInLatestOrSelectedStagingBuild: false,
                    isInLatestWorkingBranchBuild: false,
                    associatedStabilityIssues: [],
                    debugVariant: 'codeMergedWithTicket',
                },
                {
                    id: '',
                    ticket: null,
                    code: {
                        author: 'gsavit',
                        branch: 'development',
                        committedAt: '2023-05-25T16:48:06Z',
                        identifier: '1af5152',
                        message: 'update readme for deletion',
                        status: 'merged',
                        type: 'commit',
                        url: 'https://github.com/demo/-ios/commit/1af51527785d03b0aa3db5e78c318211592d1e00',
                        manualCherryPickCommands: [],
                        manualCherryPickContext: null,
                        sourcePR: null,
                    },
                    explanationText:
                        'This code exists in the diff for the release; no ticket is referenced by this code',
                    ignored: false,
                    autoIgnored: false,
                    isItemDone: true,
                    isInLatestOrSelectedStagingBuild: false,
                    isInLatestWorkingBranchBuild: false,
                    associatedStabilityIssues: [],
                    debugVariant: 'codeMergedNoTicket',
                },
                {
                    id: '',
                    ticket: null,
                    code: {
                        author: 'runway-github[bot]',
                        branch: 'development',
                        committedAt: '2023-05-23T01:07:38Z',
                        identifier: 'b8fcbcc',
                        message:
                            'Bumping version to 3.103.0 (#177)\n\nCo-authored-by: runway-github[bot] <73448015+runway-github[bot]@users.noreply.github.com>',
                        status: 'merged',
                        type: 'commit',
                        url: 'https://github.com/demo/-ios/commit/b8fcbcca0161c23d2045536edb8d4f1d1a22c391',
                        manualCherryPickCommands: [],
                        manualCherryPickContext: null,
                        sourcePR: null,
                    },
                    explanationText:
                        'This code exists in the diff for the release; no ticket is referenced by this code',
                    ignored: false,
                    autoIgnored: false,
                    isItemDone: true,
                    isInLatestOrSelectedStagingBuild: false,
                    isInLatestWorkingBranchBuild: false,
                    associatedStabilityIssues: [],
                    debugVariant: 'codeMergedNoTicket',
                },
                {
                    id: '',
                    ticket: null,
                    code: {
                        author: 'runway-github[bot]',
                        branch: 'development',
                        committedAt: '2023-05-21T19:22:32Z',
                        identifier: '1afd6d0',
                        message:
                            'Merge pull request #176 from demo/runway-backmerge-release-3.102.0-20230521192229\n\nRunway backmerged release branch `release-3.103.0` to working branch `release-3.103.0` <Tab PR Body>',
                        status: 'merged',
                        type: 'commit',
                        url: 'https://github.com/demo/-ios/commit/1afd6d086213b431967f409ae34f3c4297531598',
                        manualCherryPickCommands: [],
                        manualCherryPickContext: null,
                        sourcePR: null,
                    },
                    explanationText:
                        'This code exists in the diff for the release; no ticket is referenced by this code',
                    ignored: false,
                    autoIgnored: false,
                    isItemDone: true,
                    isInLatestOrSelectedStagingBuild: false,
                    isInLatestWorkingBranchBuild: false,
                    associatedStabilityIssues: [],
                    debugVariant: 'codeMergedNoTicket',
                },
            ],
        },
    ];
};

export const generateBuildDistributionDemoData = (): BuildDistroReducerType => {
    const rawObject: RecursiveStringifyEnums<BuildDistroReducerType> = {
        bucketsById: {
            bucket_mw53JYI0: {
                id: 'bucket_mw53JYI0',
                name: 'CIs',
                type: 'rc',
                integrationInstallationIds: [],
                rules: [
                    {
                        type: 'Branch',
                        workflowData: {
                            workflowId: 'build-app-store',
                            appSlug: '6398a8a1fb9f4bd3',
                            workflowName: 'build-app-store',
                            workflowUrl: '',
                        },
                        filterByVCSUsers: [],
                        filterByVCSUsersBehavior: BuildDistroFilterByVCSUsersBehaviorType.Include,
                        fileFilterPatterns: [],
                        branch: 'release-{version}',
                        isTokenizedBranch: true,
                        pullInAdditionalArtifacts: false,
                    },
                ],
                disallowedActions: [],
                members: [
                    {
                        type: 'user',
                        id: 'ssullenberger@demo.com',
                        permissionLevel: 'admin',
                    },
                    {
                        type: 'user',
                        id: 'aearhart@demo.com',
                        permissionLevel: 'uploader',
                    },
                    {
                        type: 'role',
                        id: 'em',
                        permissionLevel: 'tester',
                    },
                    {
                        type: 'role',
                        id: 'pm',
                        permissionLevel: 'tester',
                    },
                    {
                        type: 'role',
                        id: 'qa',
                        permissionLevel: 'tester',
                    },
                    {
                        type: 'role',
                        id: 'pilot',
                        permissionLevel: 'tester',
                    },
                ],
                orgWideAccessEnabled: false,
                publicBucketLinkEnabled: false,
                publicHash: '',
                status: 'active',
                createdAt: '2023-05-05T18:38:41.943088127Z',
                createdBy: 'dave@test.com',
                archivedAt: null,
                automations: [
                    {
                        type: 'BA_AutoTriggerBuildSystemWorkflow',
                        id: 'BA_AutoTriggerBuildSystemWorkflow',
                        stepConfigId: null,
                        integrationInstallationIds: [],
                        name: 'Trigger build workflow ',
                        description:
                            'Runway will trigger a build workflow run when needed based on your bucket configuration.',
                        requiredCapabilities: [['buildSystem'], ['versionControl']],
                        unsupportedIntegrations: null,
                        supportedPlatforms: ['ios', 'android'],
                        enabled: false,
                        data: null,
                        isNew: false,
                        isBeta: false,
                        platform: 'ios',
                        appStoreType: 'AppStoreConnect',
                        relativeTimeTrigger: {
                            enabled: false,
                            timing: 'onTime',
                            relativeDays: 0,
                            relativeHours: 0,
                            relativeMinutes: 0,
                            lifecycleEventType: 'kickoff',
                            waitForAllDestinations: true,
                        },
                        completedStepsTrigger: {
                            enabled: false,
                            hasCustomRequiredSteps: false,
                            requiredSteps: [],
                        },
                    },
                    {
                        type: 'BA_AutoGenerateBuildTesterNotes',
                        id: 'BA_AutoGenerateBuildTesterNotes',
                        stepConfigId: null,
                        integrationInstallationIds: [],
                        name: 'Generate tester notes from the work items diff for the build',
                        description:
                            'Runway will generate and apply build tester notes using the work items diff for the build.',
                        requiredCapabilities: [['buildSystem'], ['versionControl']],
                        unsupportedIntegrations: null,
                        supportedPlatforms: ['ios', 'android'],
                        enabled: false,
                        data: null,
                        isNew: false,
                        isBeta: false,
                        platform: 'ios',
                        appStoreType: 'AppStoreConnect',
                        relativeTimeTrigger: {
                            enabled: false,
                            timing: 'onTime',
                            relativeDays: 0,
                            relativeHours: 0,
                            relativeMinutes: 0,
                            lifecycleEventType: 'kickoff',
                            waitForAllDestinations: true,
                        },
                        completedStepsTrigger: {
                            enabled: false,
                            hasCustomRequiredSteps: false,
                            requiredSteps: [],
                        },
                    },
                    {
                        id: 'AutoUpdatePRWithArtifactLink',
                        type: 'AutoUpdatePRWithArtifactLink',
                        stepConfigId: null,
                        integrationInstallationIds: [],
                        name: 'Post installation QR code on open PRs',
                        description:
                            'Runway will post an installation QR code if a build is available for installation on open PRs against a given branch. Note that the bucket must be configured to pull in builds from open PRs against a base branch for this automation',
                        requiredCapabilities: [['buildSystem'], ['versionControl']],
                        unsupportedIntegrations: null,
                        supportedPlatforms: ['ios', 'android', 'tvos'],
                        enabled: false,
                        data: null,
                        isNew: false,
                        isBeta: false,
                        platform: 'ios',
                        appStoreType: 'AppStoreConnect',
                        relativeTimeTrigger: {
                            enabled: false,
                            timing: 'onTime',
                            relativeDays: 0,
                            relativeHours: 0,
                            relativeMinutes: 0,
                            lifecycleEventType: 'kickoff',
                            waitForAllDestinations: true,
                        },
                        completedStepsTrigger: {
                            enabled: false,
                            hasCustomRequiredSteps: false,
                            requiredSteps: [],
                        },
                    },
                    {
                        data: {
                            uploadRule: 'uploadNewestBuildOnly',
                            uploadWorkflowSettings: [
                                {
                                    destinationInstallationId: 'apple-beta:12345',
                                    fileNames: ['appollo.ipa'],
                                    workflowType: 'staging',
                                },
                            ],
                        },
                        description:
                            'Runway will upload build artifacts for further distribution according to the rules defined below.',
                        enabled: false,
                        type: 'BA_AutoUploadBinaryArtifactToAppStore',
                        id: 'BA_AutoUploadBinaryArtifactToAppStore',
                        stepConfigId: null,
                        integrationInstallationIds: [],
                        isNew: false,
                        isBeta: false,
                        name: 'Upload build artifacts for further distribution',
                        requiredCapabilities: [['appStore', 'betaTesting'], ['buildSystem']],
                        supportedPlatforms: ['ios', 'tvos', 'android'],
                        unsupportedIntegrations: null,
                        platform: 'ios',
                        appStoreType: 'AppStoreConnect',
                        relativeTimeTrigger: {
                            enabled: false,
                            timing: 'onTime',
                            relativeDays: 0,
                            relativeHours: 0,
                            relativeMinutes: 0,
                            lifecycleEventType: 'kickoff',
                            waitForAllDestinations: true,
                        },
                        completedStepsTrigger: {
                            enabled: false,
                            hasCustomRequiredSteps: false,
                            requiredSteps: [],
                        },
                    },
                ],
                notificationsEnabled: true,
                notifications: [
                    {
                        id: 'NEW_BUILDS_AVAILABLE',
                        displayText: 'New build available in build distribution bucket',
                        info: 'A new build is available in a given bucket and ready to install.',
                        enabled: true,
                        channels: [],
                    },
                ],
                totalBuildsCount: 5,
                artifactTypes: [],
                buildIds: ['build_TPhMC1JA', 'build_fjkOmdPF', 'build_E9EhqL7t', 'build_p8DOI5HY', 'build_xV5QlwhM'],
                recentBuildIds: [
                    'build_TPhMC1JA',
                    'build_fjkOmdPF',
                    'build_E9EhqL7t',
                    'build_p8DOI5HY',
                    'build_xV5QlwhM',
                ],
            },
            bucket_vR7t1ios: {
                id: 'bucket_vR7t1ios',
                name: 'Development',
                type: 'dev',
                rules: [
                    {
                        type: 'Branch',
                        workflowData: {
                            workflowId: 'adhoc',
                            appSlug: '6398a8a1fb9f4bd3',
                            workflowName: 'adhoc',
                            workflowUrl: '',
                        },
                        filterByVCSUsers: [],
                        filterByVCSUsersBehavior: BuildDistroFilterByVCSUsersBehaviorType.Include,
                        fileFilterPatterns: [],
                        branch: 'development',
                        isTokenizedBranch: false,
                        pullInAdditionalArtifacts: false,
                    },
                ],
                integrationInstallationIds: [],
                disallowedActions: [],
                members: [
                    {
                        type: 'role',
                        id: 'engineer',
                        permissionLevel: 'tester',
                    },
                    {
                        type: 'role',
                        id: 'pm',
                        permissionLevel: 'tester',
                    },
                    {
                        type: 'role',
                        id: 'qa',
                        permissionLevel: 'tester',
                    },
                    {
                        type: 'user',
                        id: 'abbey@test.com',
                        permissionLevel: 'admin',
                    },
                    {
                        type: 'user',
                        id: 'adrian@test.com',
                        permissionLevel: 'admin',
                    },
                    {
                        type: 'user',
                        id: 'dave@test.com',
                        permissionLevel: 'admin',
                    },
                    {
                        type: 'user',
                        id: 'keegan@test.com',
                        permissionLevel: 'admin',
                    },
                    {
                        type: 'role',
                        id: 'em',
                        permissionLevel: 'tester',
                    },
                ],
                orgWideAccessEnabled: true,
                publicBucketLinkEnabled: false,
                publicHash: '',
                status: 'active',
                createdAt: '2023-05-05T18:38:41.970073854Z',
                createdBy: 'dave@test.com',
                archivedAt: null,
                automations: [
                    {
                        type: 'BA_AutoTriggerBuildSystemWorkflow',
                        id: 'BA_AutoTriggerBuildSystemWorkflow',
                        stepConfigId: null,
                        integrationInstallationIds: [],
                        name: 'Trigger build workflow ',
                        description:
                            'Runway will trigger a build workflow run when needed based on your bucket configuration.',
                        requiredCapabilities: [['buildSystem'], ['versionControl']],
                        unsupportedIntegrations: null,
                        supportedPlatforms: ['ios', 'android'],
                        enabled: false,
                        data: null,
                        isNew: false,
                        isBeta: false,
                        platform: 'ios',
                        appStoreType: 'AppStoreConnect',
                        relativeTimeTrigger: {
                            enabled: false,
                            timing: 'onTime',
                            relativeDays: 0,
                            relativeHours: 0,
                            relativeMinutes: 0,
                            lifecycleEventType: 'kickoff',
                            waitForAllDestinations: true,
                        },
                        completedStepsTrigger: {
                            enabled: false,
                            hasCustomRequiredSteps: false,
                            requiredSteps: [],
                        },
                    },
                    {
                        type: 'BA_AutoGenerateBuildTesterNotes',
                        id: 'BA_AutoGenerateBuildTesterNotes',
                        stepConfigId: null,
                        integrationInstallationIds: [],
                        name: 'Generate tester notes from the work items diff for the build',
                        description:
                            'Runway will generate and apply build tester notes using the work items diff for the build.',
                        requiredCapabilities: [['buildSystem'], ['versionControl']],
                        unsupportedIntegrations: null,
                        supportedPlatforms: ['ios', 'android'],
                        enabled: false,
                        data: null,
                        isNew: false,
                        isBeta: false,
                        platform: 'ios',
                        appStoreType: 'AppStoreConnect',
                        relativeTimeTrigger: {
                            enabled: false,
                            timing: 'onTime',
                            relativeDays: 0,
                            relativeHours: 0,
                            relativeMinutes: 0,
                            lifecycleEventType: 'kickoff',
                            waitForAllDestinations: true,
                        },
                        completedStepsTrigger: {
                            enabled: false,
                            hasCustomRequiredSteps: false,
                            requiredSteps: [],
                        },
                    },
                    {
                        id: 'AutoUpdatePRWithArtifactLink',
                        type: 'AutoUpdatePRWithArtifactLink',
                        stepConfigId: null,
                        integrationInstallationIds: [],
                        name: 'Post installation QR code on open PRs',
                        description:
                            'Runway will post an installation QR code if a build is available for installation on open PRs against a given branch. Note that the bucket must be configured to pull in builds from open PRs against a base branch for this automation',
                        requiredCapabilities: [['buildSystem'], ['versionControl']],
                        unsupportedIntegrations: ['gitlab-vcs', 'azure-vcs', 'bitbucket'],
                        supportedPlatforms: ['ios', 'android', 'tvos'],
                        enabled: false,
                        data: null,
                        isNew: false,
                        isBeta: false,
                        platform: 'ios',
                        appStoreType: 'AppStoreConnect',
                        relativeTimeTrigger: {
                            enabled: false,
                            timing: 'onTime',
                            relativeDays: 0,
                            relativeHours: 0,
                            relativeMinutes: 0,
                            lifecycleEventType: 'kickoff',
                            waitForAllDestinations: true,
                        },
                        completedStepsTrigger: {
                            enabled: false,
                            hasCustomRequiredSteps: false,
                            requiredSteps: [],
                        },
                    },
                    {
                        data: {
                            uploadRule: 'uploadNewestBuildOnly',
                            uploadWorkflowSettings: [
                                {
                                    destinationInstallationId: 'apple-beta:12345',
                                    fileNames: ['appollo.ipa'],
                                    workflowType: 'staging',
                                },
                            ],
                        },
                        description:
                            'Runway will upload build artifacts for further distribution according to the rules defined below.',
                        enabled: false,
                        type: 'BA_AutoUploadBinaryArtifactToAppStore',
                        id: 'BA_AutoUploadBinaryArtifactToAppStore',
                        stepConfigId: null,
                        integrationInstallationIds: [],
                        isNew: false,
                        isBeta: false,
                        name: 'Upload build artifacts for further distribution',
                        requiredCapabilities: [['appStore', 'betaTesting'], ['buildSystem']],
                        supportedPlatforms: ['ios', 'tvos', 'android'],
                        unsupportedIntegrations: null,
                        platform: 'ios',
                        appStoreType: 'AppStoreConnect',
                        relativeTimeTrigger: {
                            enabled: false,
                            timing: 'onTime',
                            relativeDays: 0,
                            relativeHours: 0,
                            relativeMinutes: 0,
                            lifecycleEventType: 'kickoff',
                            waitForAllDestinations: true,
                        },
                        completedStepsTrigger: {
                            enabled: false,
                            hasCustomRequiredSteps: false,
                            requiredSteps: [],
                        },
                    },
                ],
                notificationsEnabled: true,
                notifications: [
                    {
                        id: 'NEW_BUILDS_AVAILABLE',
                        displayText: 'New build available in build distribution bucket',
                        info: 'A new build is available in a given bucket and ready to install.',
                        enabled: true,
                        channels: [],
                    },
                ],
                totalBuildsCount: 2,
                artifactTypes: [],
                buildIds: ['build_zD4kNios', 'build_zD4kNio2'],
                recentBuildIds: ['build_zD4kNios', 'build_zD4kNio2'],
            },
            bucket_vR7t1UA2: {
                id: 'bucket_vR7t1UA2',
                name: 'Development',
                type: 'dev',
                integrationInstallationIds: [],
                rules: [
                    {
                        type: 'Branch',
                        workflowData: {
                            workflowId: 'adhoc',
                            appSlug: '6398a8a1fb9f4bd3',
                            workflowName: 'adhoc',
                            workflowUrl: '',
                        },
                        filterByVCSUsers: [],
                        filterByVCSUsersBehavior: BuildDistroFilterByVCSUsersBehaviorType.Include,
                        fileFilterPatterns: [],
                        branch: 'development',
                        isTokenizedBranch: false,
                        pullInAdditionalArtifacts: false,
                    },
                ],
                disallowedActions: [],
                members: [
                    {
                        type: 'role',
                        id: 'engineer',
                        permissionLevel: 'tester',
                    },
                    {
                        type: 'role',
                        id: 'pm',
                        permissionLevel: 'tester',
                    },
                    {
                        type: 'role',
                        id: 'qa',
                        permissionLevel: 'tester',
                    },
                    {
                        type: 'role',
                        id: 'em',
                        permissionLevel: 'tester',
                    },
                ],
                orgWideAccessEnabled: true,
                publicBucketLinkEnabled: false,
                publicHash: '',
                status: 'active',
                createdAt: '2023-05-05T18:38:41.970073854Z',
                createdBy: 'dave@test.com',
                archivedAt: null,
                automations: [
                    {
                        type: 'BA_AutoTriggerBuildSystemWorkflow',
                        id: 'BA_AutoTriggerBuildSystemWorkflow',
                        stepConfigId: null,
                        integrationInstallationIds: [],
                        name: 'Trigger build workflow ',
                        description:
                            'Runway will trigger a build workflow run when needed based on your bucket configuration.',
                        requiredCapabilities: [['buildSystem'], ['versionControl']],
                        unsupportedIntegrations: null,
                        supportedPlatforms: ['ios', 'android'],
                        enabled: false,
                        data: null,
                        isNew: false,
                        isBeta: false,
                        platform: 'ios',
                        appStoreType: 'AppStoreConnect',
                        relativeTimeTrigger: {
                            enabled: false,
                            timing: 'onTime',
                            relativeDays: 0,
                            relativeHours: 0,
                            relativeMinutes: 0,
                            lifecycleEventType: 'kickoff',
                            waitForAllDestinations: true,
                        },
                        completedStepsTrigger: {
                            enabled: false,
                            hasCustomRequiredSteps: false,
                            requiredSteps: [],
                        },
                    },
                    {
                        type: 'BA_AutoGenerateBuildTesterNotes',
                        id: 'BA_AutoGenerateBuildTesterNotes',
                        stepConfigId: null,
                        integrationInstallationIds: [],
                        name: 'Generate tester notes from the work items diff for the build',
                        description:
                            'Runway will generate and apply build tester notes using the work items diff for the build.',
                        requiredCapabilities: [['buildSystem'], ['versionControl']],
                        unsupportedIntegrations: null,
                        supportedPlatforms: ['ios', 'android'],
                        enabled: false,
                        data: null,
                        isNew: false,
                        isBeta: false,
                        platform: 'ios',
                        appStoreType: 'AppStoreConnect',
                        relativeTimeTrigger: {
                            enabled: false,
                            timing: 'onTime',
                            relativeDays: 0,
                            relativeHours: 0,
                            relativeMinutes: 0,
                            lifecycleEventType: 'kickoff',
                            waitForAllDestinations: true,
                        },
                        completedStepsTrigger: {
                            enabled: false,
                            hasCustomRequiredSteps: false,
                            requiredSteps: [],
                        },
                    },
                    {
                        id: 'AutoUpdatePRWithArtifactLink',
                        type: 'AutoUpdatePRWithArtifactLink',
                        stepConfigId: null,
                        integrationInstallationIds: [],
                        name: 'Post installation QR code on open PRs',
                        description:
                            'Runway will post an installation QR code if a build is available for installation on open PRs against a given branch. Note that the bucket must be configured to pull in builds from open PRs against a base branch for this automation',
                        requiredCapabilities: [['buildSystem'], ['versionControl']],
                        unsupportedIntegrations: ['gitlab-vcs', 'azure-vcs', 'bitbucket'],
                        supportedPlatforms: ['ios', 'android', 'tvos'],
                        enabled: false,
                        data: null,
                        isNew: false,
                        isBeta: false,
                        platform: 'ios',
                        appStoreType: 'AppStoreConnect',
                        relativeTimeTrigger: {
                            enabled: false,
                            timing: 'onTime',
                            relativeDays: 0,
                            relativeHours: 0,
                            relativeMinutes: 0,
                            lifecycleEventType: 'kickoff',
                            waitForAllDestinations: true,
                        },
                        completedStepsTrigger: {
                            enabled: false,
                            hasCustomRequiredSteps: false,
                            requiredSteps: [],
                        },
                    },
                    {
                        data: {
                            uploadRule: 'uploadNewestBuildOnly',
                            uploadWorkflowSettings: [
                                {
                                    destinationInstallationId: 'apple-beta:12345',
                                    fileNames: ['appollo.ipa'],
                                    workflowType: 'staging',
                                },
                            ],
                        },
                        description:
                            'Runway will upload build artifacts for further distribution according to the rules defined below.',
                        enabled: false,
                        type: 'BA_AutoUploadBinaryArtifactToAppStore',
                        id: 'BA_AutoUploadBinaryArtifactToAppStore',
                        stepConfigId: null,
                        integrationInstallationIds: [],
                        isNew: false,
                        isBeta: false,
                        name: 'Upload build artifacts for further distribution',
                        requiredCapabilities: [['appStore', 'betaTesting'], ['buildSystem']],
                        supportedPlatforms: ['ios', 'tvos', 'android'],
                        unsupportedIntegrations: null,
                        platform: 'ios',
                        appStoreType: 'AppStoreConnect',
                        relativeTimeTrigger: {
                            enabled: false,
                            timing: 'onTime',
                            relativeDays: 0,
                            relativeHours: 0,
                            relativeMinutes: 0,
                            lifecycleEventType: 'kickoff',
                            waitForAllDestinations: true,
                        },
                        completedStepsTrigger: {
                            enabled: false,
                            hasCustomRequiredSteps: false,
                            requiredSteps: [],
                        },
                    },
                ],
                notificationsEnabled: true,
                notifications: [
                    {
                        id: 'NEW_BUILDS_AVAILABLE',
                        displayText: 'New build available in build distribution bucket',
                        info: 'A new build is available in a given bucket and ready to install.',
                        enabled: true,
                        channels: [],
                    },
                ],
                totalBuildsCount: 2,
                artifactTypes: [],
                buildIds: ['build_PFCcQepd', 'build_EppuDgtT'],
                recentBuildIds: ['build_PFCcQepd', 'build_EppuDgtT'],
            },
            bucket_NT5awios: {
                id: 'bucket_NT5awios',
                name: 'Your personal bucket',
                type: 'personal',
                rules: [],
                disallowedActions: [],
                integrationInstallationIds: [],
                members: [
                    {
                        type: 'user',
                        id: 'adrian@test.com',
                        permissionLevel: 'admin',
                    },
                ],
                orgWideAccessEnabled: false,
                publicBucketLinkEnabled: false,
                publicHash: '',
                status: 'active',
                createdAt: '2023-05-05T18:38:42.021831355Z',
                createdBy: 'adrian@test.com',
                archivedAt: null,
                automations: [
                    {
                        type: 'BA_AutoTriggerBuildSystemWorkflow',
                        id: 'BA_AutoTriggerBuildSystemWorkflow',
                        stepConfigId: null,
                        integrationInstallationIds: [],
                        name: 'Trigger build workflow ',
                        description:
                            'Runway will trigger a build workflow run when needed based on your bucket configuration.',
                        requiredCapabilities: [['buildSystem'], ['versionControl']],
                        unsupportedIntegrations: null,
                        supportedPlatforms: ['ios', 'android'],
                        enabled: false,
                        data: null,
                        isNew: false,
                        isBeta: false,
                        platform: 'ios',
                        appStoreType: 'AppStoreConnect',
                        relativeTimeTrigger: {
                            enabled: false,
                            timing: 'onTime',
                            relativeDays: 0,
                            relativeHours: 0,
                            relativeMinutes: 0,
                            lifecycleEventType: 'kickoff',
                            waitForAllDestinations: true,
                        },
                        completedStepsTrigger: {
                            enabled: false,
                            hasCustomRequiredSteps: false,
                            requiredSteps: [],
                        },
                    },
                    {
                        type: 'BA_AutoGenerateBuildTesterNotes',
                        id: 'BA_AutoGenerateBuildTesterNotes',
                        stepConfigId: null,
                        integrationInstallationIds: [],
                        name: 'Generate tester notes from the work items diff for the build',
                        description:
                            'Runway will generate and apply build tester notes using the work items diff for the build.',
                        requiredCapabilities: [['buildSystem'], ['versionControl']],
                        unsupportedIntegrations: null,
                        supportedPlatforms: ['ios', 'android'],
                        enabled: false,
                        data: null,
                        isNew: false,
                        isBeta: false,
                        platform: 'ios',
                        appStoreType: 'AppStoreConnect',
                        relativeTimeTrigger: {
                            enabled: false,
                            timing: 'onTime',
                            relativeDays: 0,
                            relativeHours: 0,
                            relativeMinutes: 0,
                            lifecycleEventType: 'kickoff',
                            waitForAllDestinations: true,
                        },
                        completedStepsTrigger: {
                            enabled: false,
                            hasCustomRequiredSteps: false,
                            requiredSteps: [],
                        },
                    },
                    {
                        id: 'AutoUpdatePRWithArtifactLink',
                        type: 'AutoUpdatePRWithArtifactLink',
                        stepConfigId: null,
                        integrationInstallationIds: [],
                        name: 'Post installation QR code on open PRs',
                        description:
                            'Runway will post an installation QR code if a build is available for installation on open PRs against a given branch. Note that the bucket must be configured to pull in builds from open PRs against a base branch for this automation',
                        requiredCapabilities: [['buildSystem'], ['versionControl']],
                        unsupportedIntegrations: ['gitlab-vcs', 'azure-vcs', 'bitbucket'],
                        supportedPlatforms: ['ios', 'android', 'tvos'],
                        enabled: false,
                        data: null,
                        isNew: false,
                        isBeta: false,
                        platform: 'ios',
                        appStoreType: 'AppStoreConnect',
                        relativeTimeTrigger: {
                            enabled: false,
                            timing: 'onTime',
                            relativeDays: 0,
                            relativeHours: 0,
                            relativeMinutes: 0,
                            lifecycleEventType: 'kickoff',
                            waitForAllDestinations: true,
                        },
                        completedStepsTrigger: {
                            enabled: false,
                            hasCustomRequiredSteps: false,
                            requiredSteps: [],
                        },
                    },
                    {
                        data: {
                            uploadRule: 'uploadNewestBuildOnly',
                            uploadWorkflowSettings: [
                                {
                                    destinationInstallationId: 'apple-beta:12345',
                                    fileNames: ['appollo.ipa'],
                                    workflowType: 'staging',
                                },
                            ],
                        },
                        description:
                            'Runway will upload build artifacts for further distribution according to the rules defined below.',
                        enabled: false,
                        type: 'BA_AutoUploadBinaryArtifactToAppStore',
                        id: 'BA_AutoUploadBinaryArtifactToAppStore',
                        stepConfigId: null,
                        integrationInstallationIds: [],
                        isNew: false,
                        isBeta: false,
                        name: 'Upload build artifacts for further distribution',
                        requiredCapabilities: [['appStore', 'betaTesting'], ['buildSystem']],
                        supportedPlatforms: ['ios', 'tvos', 'android'],
                        unsupportedIntegrations: null,
                        platform: 'ios',
                        appStoreType: 'AppStoreConnect',
                        relativeTimeTrigger: {
                            enabled: false,
                            timing: 'onTime',
                            relativeDays: 0,
                            relativeHours: 0,
                            relativeMinutes: 0,
                            lifecycleEventType: 'kickoff',
                            waitForAllDestinations: true,
                        },
                        completedStepsTrigger: {
                            enabled: false,
                            hasCustomRequiredSteps: false,
                            requiredSteps: [],
                        },
                    },
                ],
                notificationsEnabled: true,
                notifications: [
                    {
                        id: 'NEW_BUILDS_AVAILABLE',
                        displayText: 'New build available in build distribution bucket',
                        info: 'A new build is available in a given bucket and ready to install.',
                        enabled: false,
                        channels: [],
                    },
                ],
                totalBuildsCount: 1,
                artifactTypes: [],
                buildIds: ['build_6EN6t3j2'],
                recentBuildIds: ['build_6EN6t3j2'],
            },
            bucket_NT5awsf6: {
                id: 'bucket_NT5awsf6',
                name: 'Your personal bucket',
                type: 'personal',
                rules: [],
                disallowedActions: [],
                members: [],
                orgWideAccessEnabled: false,
                publicBucketLinkEnabled: false,
                publicHash: '',
                status: 'active',
                integrationInstallationIds: [],
                createdAt: '2023-05-05T18:38:42.021831355Z',
                createdBy: 'adrian@test.com',
                archivedAt: null,
                automations: [
                    {
                        type: 'BA_AutoTriggerBuildSystemWorkflow',
                        id: 'BA_AutoTriggerBuildSystemWorkflow',
                        stepConfigId: null,
                        integrationInstallationIds: [],
                        name: 'Trigger build workflow ',
                        description:
                            'Runway will trigger a build workflow run when needed based on your bucket configuration.',
                        requiredCapabilities: [['buildSystem'], ['versionControl']],
                        unsupportedIntegrations: null,
                        supportedPlatforms: ['ios', 'android'],
                        enabled: false,
                        data: null,
                        isNew: false,
                        isBeta: false,
                        platform: 'ios',
                        appStoreType: 'AppStoreConnect',
                        relativeTimeTrigger: {
                            enabled: false,
                            timing: 'onTime',
                            relativeDays: 0,
                            relativeHours: 0,
                            relativeMinutes: 0,
                            lifecycleEventType: 'kickoff',
                            waitForAllDestinations: true,
                        },
                        completedStepsTrigger: {
                            enabled: false,
                            hasCustomRequiredSteps: false,
                            requiredSteps: [],
                        },
                    },
                    {
                        type: 'BA_AutoGenerateBuildTesterNotes',
                        id: 'BA_AutoGenerateBuildTesterNotes',
                        stepConfigId: null,
                        integrationInstallationIds: [],
                        name: 'Generate tester notes from the work items diff for the build',
                        description:
                            'Runway will generate and apply build tester notes using the work items diff for the build.',
                        requiredCapabilities: [['buildSystem'], ['versionControl']],
                        unsupportedIntegrations: null,
                        supportedPlatforms: ['ios', 'android'],
                        enabled: false,
                        data: null,
                        isNew: false,
                        isBeta: false,
                        platform: 'ios',
                        appStoreType: 'AppStoreConnect',
                        relativeTimeTrigger: {
                            enabled: false,
                            timing: 'onTime',
                            relativeDays: 0,
                            relativeHours: 0,
                            relativeMinutes: 0,
                            lifecycleEventType: 'kickoff',
                            waitForAllDestinations: true,
                        },
                        completedStepsTrigger: {
                            enabled: false,
                            hasCustomRequiredSteps: false,
                            requiredSteps: [],
                        },
                    },
                    {
                        id: 'AutoUpdatePRWithArtifactLink',
                        type: 'AutoUpdatePRWithArtifactLink',
                        stepConfigId: null,
                        integrationInstallationIds: [],
                        name: 'Post installation QR code on open PRs',
                        description:
                            'Runway will post an installation QR code if a build is available for installation on open PRs against a given branch. Note that the bucket must be configured to pull in builds from open PRs against a base branch for this automation',
                        requiredCapabilities: [['buildSystem'], ['versionControl']],
                        unsupportedIntegrations: ['gitlab-vcs', 'azure-vcs', 'bitbucket'],
                        supportedPlatforms: ['ios', 'android', 'tvos'],
                        enabled: false,
                        data: null,
                        isNew: false,
                        isBeta: false,
                        platform: 'ios',
                        appStoreType: 'AppStoreConnect',
                        relativeTimeTrigger: {
                            enabled: false,
                            timing: 'onTime',
                            relativeDays: 0,
                            relativeHours: 0,
                            relativeMinutes: 0,
                            lifecycleEventType: 'kickoff',
                            waitForAllDestinations: true,
                        },
                        completedStepsTrigger: {
                            enabled: false,
                            hasCustomRequiredSteps: false,
                            requiredSteps: [],
                        },
                    },
                    {
                        data: {
                            uploadRule: 'uploadNewestBuildOnly',
                            uploadWorkflowSettings: [
                                {
                                    destinationInstallationId: 'apple-beta:12345',
                                    fileNames: ['appollo.ipa'],
                                    workflowType: 'staging',
                                },
                            ],
                        },
                        description:
                            'Runway will upload build artifacts for further distribution according to the rules defined below.',
                        enabled: false,
                        type: 'BA_AutoUploadBinaryArtifactToAppStore',
                        id: 'BA_AutoUploadBinaryArtifactToAppStore',
                        stepConfigId: null,
                        integrationInstallationIds: [],
                        isNew: false,
                        isBeta: false,
                        name: 'Upload build artifacts for further distribution',
                        requiredCapabilities: [['appStore', 'betaTesting'], ['buildSystem']],
                        supportedPlatforms: ['ios', 'tvos', 'android'],
                        unsupportedIntegrations: null,
                        platform: 'ios',
                        appStoreType: 'AppStoreConnect',
                        relativeTimeTrigger: {
                            enabled: false,
                            timing: 'onTime',
                            relativeDays: 0,
                            relativeHours: 0,
                            relativeMinutes: 0,
                            lifecycleEventType: 'kickoff',
                            waitForAllDestinations: true,
                        },
                        completedStepsTrigger: {
                            enabled: false,
                            hasCustomRequiredSteps: false,
                            requiredSteps: [],
                        },
                    },
                ],
                notificationsEnabled: true,
                notifications: [
                    {
                        id: 'NEW_BUILDS_AVAILABLE',
                        displayText: 'New build available in build distribution bucket',
                        info: 'A new build is available in a given bucket and ready to install.',
                        enabled: false,
                        channels: [],
                    },
                ],
                totalBuildsCount: 2,
                artifactTypes: [],
                buildIds: ['build_PFCcQep2', 'build_PFCcQep3'],
                recentBuildIds: ['build_PFCcQep2', 'build_PFCcQep3'],
            },
            bucket_WosLAtJQ: {
                id: 'bucket_WosLAtJQ',
                name: 'CIs',
                type: 'rc',
                integrationInstallationIds: [],
                rules: [
                    {
                        type: 'Branch',
                        workflowData: {
                            workflowId: 'build-app-store',
                            appSlug: '6398a8a1fb9f4bd3',
                            workflowName: 'build-app-store',
                            workflowUrl: '',
                        },
                        filterByVCSUsers: [],
                        filterByVCSUsersBehavior: BuildDistroFilterByVCSUsersBehaviorType.Include,
                        fileFilterPatterns: [],
                        branch: 'release-{version}',
                        isTokenizedBranch: true,
                        pullInAdditionalArtifacts: false,
                    },
                ],
                members: [
                    {
                        type: 'user',
                        id: 'ssullenberger@demo.com',
                        permissionLevel: 'admin',
                    },
                    {
                        type: 'user',
                        id: 'aearhart@demo.com',
                        permissionLevel: 'uploader',
                    },
                    {
                        type: 'role',
                        id: 'em',
                        permissionLevel: 'tester',
                    },
                    {
                        type: 'role',
                        id: 'pm',
                        permissionLevel: 'tester',
                    },
                    {
                        type: 'role',
                        id: 'qa',
                        permissionLevel: 'tester',
                    },
                    {
                        type: 'role',
                        id: 'pilot',
                        permissionLevel: 'tester',
                    },
                ],
                orgWideAccessEnabled: true,
                publicBucketLinkEnabled: false,
                publicHash: '',
                status: 'active',
                createdAt: '2023-05-05T18:33:23.570614326Z',
                createdBy: 'dave@test.com',
                archivedAt: null,
                automations: [
                    {
                        type: 'BA_AutoTriggerBuildSystemWorkflow',
                        id: 'BA_AutoTriggerBuildSystemWorkflow',
                        stepConfigId: null,
                        integrationInstallationIds: [],
                        name: 'Trigger build workflow ',
                        description:
                            'Runway will trigger a build workflow run when needed based on your bucket configuration.',
                        requiredCapabilities: [['buildSystem'], ['versionControl']],
                        unsupportedIntegrations: null,
                        supportedPlatforms: ['ios', 'android'],
                        enabled: false,
                        data: null,
                        isNew: false,
                        isBeta: false,
                        platform: 'ios',
                        appStoreType: 'AppStoreConnect',
                        relativeTimeTrigger: {
                            enabled: false,
                            timing: 'onTime',
                            relativeDays: 0,
                            relativeHours: 0,
                            relativeMinutes: 0,
                            lifecycleEventType: 'kickoff',
                            waitForAllDestinations: true,
                        },
                        completedStepsTrigger: {
                            enabled: false,
                            hasCustomRequiredSteps: false,
                            requiredSteps: [],
                        },
                    },
                    {
                        type: 'BA_AutoGenerateBuildTesterNotes',
                        id: 'BA_AutoGenerateBuildTesterNotes',
                        stepConfigId: null,
                        integrationInstallationIds: [],
                        name: 'Generate tester notes from the work items diff for the build',
                        description:
                            'Runway will generate and apply build tester notes using the work items diff for the build.',
                        requiredCapabilities: [['buildSystem'], ['versionControl']],
                        unsupportedIntegrations: null,
                        supportedPlatforms: ['ios', 'android'],
                        enabled: false,
                        data: null,
                        isNew: false,
                        isBeta: false,
                        platform: 'ios',
                        appStoreType: 'AppStoreConnect',
                        relativeTimeTrigger: {
                            enabled: false,
                            timing: 'onTime',
                            relativeDays: 0,
                            relativeHours: 0,
                            relativeMinutes: 0,
                            lifecycleEventType: 'kickoff',
                            waitForAllDestinations: true,
                        },
                        completedStepsTrigger: {
                            enabled: false,
                            hasCustomRequiredSteps: false,
                            requiredSteps: [],
                        },
                    },
                    {
                        id: 'AutoUpdatePRWithArtifactLink',
                        type: 'AutoUpdatePRWithArtifactLink',
                        stepConfigId: null,
                        integrationInstallationIds: [],
                        name: 'Post installation QR code on open PRs',
                        description:
                            'Runway will post an installation QR code if a build is available for installation on open PRs against a given branch. Note that the bucket must be configured to pull in builds from open PRs against a base branch for this automation',
                        requiredCapabilities: [['buildSystem'], ['versionControl']],
                        unsupportedIntegrations: ['gitlab-vcs', 'azure-vcs', 'bitbucket'],
                        supportedPlatforms: ['ios', 'android', 'tvos'],
                        enabled: false,
                        data: null,
                        isNew: false,
                        isBeta: false,
                        platform: 'ios',
                        appStoreType: 'AppStoreConnect',
                        relativeTimeTrigger: {
                            enabled: false,
                            timing: 'onTime',
                            relativeDays: 0,
                            relativeHours: 0,
                            relativeMinutes: 0,
                            lifecycleEventType: 'kickoff',
                            waitForAllDestinations: true,
                        },
                        completedStepsTrigger: {
                            enabled: false,
                            hasCustomRequiredSteps: false,
                            requiredSteps: [],
                        },
                    },
                    {
                        data: {
                            uploadRule: 'uploadNewestBuildOnly',
                            uploadWorkflowSettings: [
                                {
                                    destinationInstallationId: 'apple-beta:12345',
                                    fileNames: ['appollo.ipa'],
                                    workflowType: 'staging',
                                },
                            ],
                        },
                        description:
                            'Runway will upload build artifacts for further distribution according to the rules defined below.',
                        enabled: false,
                        type: 'BA_AutoUploadBinaryArtifactToAppStore',
                        id: 'BA_AutoUploadBinaryArtifactToAppStore',
                        stepConfigId: null,
                        integrationInstallationIds: [],
                        isNew: false,
                        isBeta: false,
                        name: 'Upload build artifacts for further distribution',
                        requiredCapabilities: [['appStore', 'betaTesting'], ['buildSystem']],
                        supportedPlatforms: ['ios', 'tvos', 'android'],
                        unsupportedIntegrations: null,
                        platform: 'ios',
                        appStoreType: 'AppStoreConnect',
                        relativeTimeTrigger: {
                            enabled: false,
                            timing: 'onTime',
                            relativeDays: 0,
                            relativeHours: 0,
                            relativeMinutes: 0,
                            lifecycleEventType: 'kickoff',
                            waitForAllDestinations: true,
                        },
                        completedStepsTrigger: {
                            enabled: false,
                            hasCustomRequiredSteps: false,
                            requiredSteps: [],
                        },
                    },
                ],
                notificationsEnabled: true,
                disallowedActions: [],
                notifications: [
                    {
                        id: 'NEW_BUILDS_AVAILABLE',
                        displayText: 'New build available in build distribution bucket',
                        info: 'A new build is available in a given bucket and ready to install.',
                        enabled: true,
                        channels: [],
                    },
                ],
                totalBuildsCount: 5,
                artifactTypes: [],
                recentBuildIds: ['build_csAS2bj5', 'build_UiFZalKE', 'build_zD4kNXCy', 'build_6EN6t3jH'],
                buildIds: ['build_csAS2bj5', 'build_UiFZalKE', 'build_zD4kNXCy', 'build_6EN6t3jH', 'build_qzXtzmUY'],
            },
        },
        allBucketIds: ['bucket_WosLAtJQ', 'bucket_vR7t1UA2', 'bucket_NT5awsf6', 'bucket_mw53JYI0'],
        buildsById: {
            build_csAS2bj5: {
                id: 'build_csAS2bj5',
                bucketId: 'bucket_WosLAtJQ',
                status: 'active',
                additionalArtifacts: [],
                binaryBuild: {
                    id: 'build_csAS2bj5',
                    type: 'ipa',
                    buildNumber: '3902',
                    buildVersion: '3.102.0',
                    provisioningProfile: {
                        id: 'XXXXXXX',
                        name: 'Demo iOS app-store - (com.demo.app)',
                        profileType: 'IOS_APP_STORE',
                        expirationDate: '2023-12-22T23:05:37Z',
                        profileState: 'ACTIVE',
                        certificates: [
                            {
                                name: 'Apple Distribution: demo, LLC',
                                expirationDate: '2023-12-22T23:05:37Z',
                                certificateType: 'DISTRIBUTION',
                            },
                        ],
                        creationDate: '2021-05-05T20:44:17.001201076Z',
                        devices: [],
                        bundleId: 'com.demo.app',
                    },
                    buildType: 'BuildArtifactIOSAppStore',
                    artifactFileName: 'appollo.ipa',
                },
                ciBuild: {
                    buildHash: 'abcd',
                    buildIdentifier: '3902',
                    integrationId: 'bitrise',
                    buildUrl: 'https://app.bitrise.io/build/2e11a267-49f8-4f5b-ae13-29b1cc631045',
                    buildStartedAt: '2023-04-11T19:40:51Z',
                    buildFinishedAt: '2023-04-11T19:46:11Z',
                    buildStatus: 'success',
                    providerBuildStatusString: 'Success',
                    commit: '073f83665eca884aacfc4eae818feead217cac46',
                    commitMessage: 'Fix bug causing app crash on startup',
                    commitAuthor: null,
                    commitUrl: null,
                    workflowRunId: '2e11a267-49f8-4f5b-ae13-29b1cc631045',
                    workflowName: 'build-app-store',
                    branchName: 'release-3.102.0',
                },
                createdAt: '2023-05-05T20:44:17.001201076Z',
                updatedAt: '2023-05-18T16:05:16.617494296Z',
                individualTesters: ['ssullenberger@demo.com', 'aearhart@demo.com', 'narmstrong@demo.com'],
                testerNotes: 'Fixes crashes',
                installationUrl:
                    '/api/org/demo/app/appollo-ios/build-distribution/build/build_csAS2bj5/install?bucketId=bucket_WosLAtJQ',
                uploadedAt: '2023-04-11T19:46:11Z',
                sharedBy: null,
                sharedOn: null,
                isMultiArtifact: false,
            } as RecursiveStringifyEnums<BuildDistroBuildSharedWithMe>,
            build_UiFZalKE: {
                id: 'build_UiFZalKE',
                bucketId: 'bucket_WosLAtJQ',
                additionalArtifacts: [],
                workItemsByBuild: generateWorkItems(),
                status: 'active',
                binaryBuild: {
                    id: 'build_UiFZalKE',
                    type: 'ipa',
                    buildNumber: '3879',
                    buildVersion: '3.102.0',
                    provisioningProfile: {
                        id: 'PJ55BNQX2M',
                        name: 'Bitrise iOS app-store - (com.demo)',
                        profileType: 'IOS_APP_STORE',
                        expirationDate: '2023-12-22T23:05:37Z',
                        profileState: 'ACTIVE',
                        certificates: [
                            {
                                name: 'Apple Distribution: demo, LLC',
                                expirationDate: '2023-12-22T23:05:37Z',
                                certificateType: 'DISTRIBUTION',
                            },
                        ],
                        creationDate: '2021-05-05T20:44:20.762661335Z',
                        devices: [],
                        bundleId: 'com.demo',
                    },
                    buildType: 'BuildArtifactIOSAppStore',
                    artifactFileName: 'appollo.ipa',
                },
                ciBuild: {
                    buildHash: '5pcUblaVjUn2Sl-yItx4emdYfzg=',
                    buildIdentifier: '3879',
                    integrationId: 'bitrise',
                    buildUrl: 'https://app.bitrise.io/build/24e5271c-cd5d-44a6-917e-7c07307f3583',
                    buildStartedAt: '2023-03-20T21:41:04Z',
                    buildFinishedAt: '2023-03-20T21:45:58Z',
                    buildStatus: 'success',
                    providerBuildStatusString: 'Success',
                    commit: 'fc1c4fdfaa72ee754e910287b339441628eb09e1',
                    commitMessage: 'Implement new user login feature',
                    commitAuthor: null,
                    commitUrl: null,
                    workflowName: 'build-app-store',
                    branchName: 'release-3.102.0',
                },
                createdAt: '2023-05-05T20:44:20.762661335Z',
                updatedAt: '2023-05-05T20:44:21.869140151Z',
                individualTesters: [],
                testerNotes: 'Implemented error handling for incorrect login credentials.',
                installationUrl:
                    '/api/org/demo/app/appollo-ios/build-distribution/build/build_UiFZalKE/install?bucketId=bucket_WosLAtJQ',
                uploadedAt: '2023-03-20T21:45:58Z',
                isMultiArtifact: false,
            },
            build_zD4kNXCy: {
                id: 'build_zD4kNXCy',
                bucketId: 'bucket_WosLAtJQ',
                additionalArtifacts: [],
                workItemsByBuild: generateWorkItems(),
                status: 'expired',
                binaryBuild: {
                    id: 'build_zD4kNXCy',
                    type: 'ipa',
                    buildNumber: '3868',
                    buildVersion: '3.102.0',
                    provisioningProfile: {
                        id: 'PJ55BNQX2M',
                        name: 'Bitrise iOS app-store - (com.demo)',
                        profileType: 'IOS_APP_STORE',
                        expirationDate: '2023-12-22T23:05:37Z',
                        profileState: 'ACTIVE',
                        certificates: [
                            {
                                name: 'Apple Distribution: demo, LLC',
                                expirationDate: '2023-12-22T23:05:37Z',
                                certificateType: 'DISTRIBUTION',
                            },
                        ],
                        creationDate: '2021-05-05T20:44:20.762661335Z',
                        devices: [],
                        bundleId: 'com.demo',
                    },
                    buildType: 'BuildArtifactIOSAppStore',
                    artifactFileName: 'appollo.ipa',
                },
                ciBuild: {
                    buildHash: '7OIlfJmMnHApP707RaVrhLeJRAY=',
                    buildIdentifier: '3868',
                    integrationId: 'bitrise',
                    buildUrl: 'https://app.bitrise.io/build/ac210079-42d0-41c4-bf25-741f3dd1997f',
                    buildStartedAt: '2023-03-18T03:02:42Z',
                    buildFinishedAt: '2023-03-18T03:07:42Z',
                    buildStatus: 'success',
                    providerBuildStatusString: 'Success',
                    commit: 'fc1c4fdfaa72ee754e910287b339441628eb09e1',
                    commitMessage: 'Optimize image loading for faster performance',
                    commitAuthor: null,
                    commitUrl: null,
                    workflowName: 'build-app-store',
                    branchName: 'release-3.102.0',
                },
                createdAt: '2023-05-05T20:44:24.834800666Z',
                updatedAt: '2023-05-05T20:44:26.958626896Z',
                individualTesters: [],
                testerNotes: 'Adjusted color contrast for better readability in dark mode.',
                installationUrl:
                    '/api/org/demo/app/appollo-ios/build-distribution/build/build_zD4kNXCy/install?bucketId=bucket_WosLAtJQ',
                uploadedAt: '2023-03-18T03:07:42Z',
                isMultiArtifact: false,
            },
            build_zD4kNios: {
                id: 'build_zD4kNios',
                bucketId: 'bucket_vR7t1ios',
                status: 'active',
                additionalArtifacts: [],
                workItemsByBuild: generateWorkItems(),
                binaryBuild: {
                    id: 'build_zD4kNios',
                    type: 'ipa',
                    buildNumber: '3868',
                    buildVersion: '3.102.0',
                    provisioningProfile: {
                        id: 'PJ55BNQX2M',
                        name: 'Bitrise iOS app-store - (com.demo)',
                        profileType: 'IOS_APP_STORE',
                        expirationDate: '2023-12-22T23:05:37Z',
                        profileState: 'ACTIVE',
                        certificates: [
                            {
                                name: 'Apple Distribution: demo, LLC',
                                expirationDate: '2023-12-22T23:05:37Z',
                                certificateType: 'DISTRIBUTION',
                            },
                        ],
                        creationDate: '2021-05-05T20:44:20.762661335Z',
                        devices: [],
                        bundleId: 'com.demo',
                    },
                    buildType: 'BuildArtifactIOSAppStore',
                    artifactFileName: 'appollo.ipa',
                },
                ciBuild: {
                    buildHash: '7OIlfJmMnHApP707RaVrhLeJRAY=',
                    buildIdentifier: '3868',
                    integrationId: 'bitrise',
                    buildUrl: 'https://app.bitrise.io/build/ac210079-42d0-41c4-bf25-741f3dd1997f',
                    buildStartedAt: '2023-03-18T03:02:42Z',
                    buildFinishedAt: '2023-03-18T03:07:42Z',
                    buildStatus: 'success',
                    providerBuildStatusString: 'Success',
                    commit: 'fc1c4fdfaa72ee754e910287b339441628eb09e1',
                    commitMessage: 'Update Info.plist',
                    commitAuthor: null,
                    commitUrl: null,
                    workflowName: 'build-app-store',
                    branchName: 'release-3.102.0',
                },
                createdAt: '2023-05-05T20:44:24.834800666Z',
                updatedAt: '2023-05-05T20:44:26.958626896Z',
                individualTesters: [],
                testerNotes: 'Updated the user profile section, including profile picture upload.',
                installationUrl:
                    '/api/org/demo/app/appollo-ios/build-distribution/build/build_zD4kNXCy/install?bucketId=bucket_WosLAtJQ',
                uploadedAt: '2023-03-18T03:07:42Z',
                isMultiArtifact: false,
            },
            build_zD4kNio2: {
                id: 'build_zD4kNio2',
                bucketId: 'bucket_vR7t1ios',
                status: 'active',
                additionalArtifacts: [],
                workItemsByBuild: generateWorkItems(),
                binaryBuild: {
                    id: 'build_zD4kNio2',
                    type: 'ipa',
                    buildNumber: '3868',
                    buildVersion: '3.102.0',
                    provisioningProfile: {
                        id: 'PJ55BNQX2M',
                        name: 'Bitrise iOS app-store - (com.demo)',
                        profileType: 'IOS_APP_STORE',
                        expirationDate: '2023-12-22T23:05:37Z',
                        profileState: 'ACTIVE',
                        certificates: [
                            {
                                name: 'Apple Distribution: demo, LLC',
                                expirationDate: '2023-12-22T23:05:37Z',
                                certificateType: 'DISTRIBUTION',
                            },
                        ],
                        creationDate: '2021-05-05T20:44:20.762661335Z',
                        devices: [],
                        bundleId: 'com.demo',
                    },
                    buildType: 'BuildArtifactIOSAppStore',
                    artifactFileName: 'appollo.ipa',
                },
                ciBuild: {
                    buildHash: '7OIlfJmMnHApP707RaVrhLeJRAY=',
                    buildIdentifier: '3868',
                    integrationId: 'bitrise',
                    buildUrl: 'https://app.bitrise.io/build/ac210079-42d0-41c4-bf25-741f3dd1997f',
                    buildStartedAt: '2023-03-18T03:02:42Z',
                    buildFinishedAt: '2023-03-18T03:07:42Z',
                    buildStatus: 'success',
                    providerBuildStatusString: 'Success',
                    commit: 'fc1c4fdfaa72ee754e910287b339441628eb09e1',
                    commitMessage: 'Revert "Optimize image loading for faster performance"',
                    commitAuthor: null,
                    commitUrl: null,
                    workflowName: 'build-app-store',
                    branchName: 'release-3.102.0',
                },
                createdAt: '2023-01-05T20:24:24.834800666Z',
                updatedAt: '2023-01-05T20:24:26.958626896Z',
                individualTesters: [],
                testerNotes: 'Implemented improvements to push notifications',
                installationUrl:
                    '/api/org/demo/app/appollo-ios/build-distribution/build/build_zD4kNXCy/install?bucketId=bucket_WosLAtJQ',
                uploadedAt: '2023-03-18T03:07:42Z',
                isMultiArtifact: false,
            },
            build_6EN6t3jH: {
                id: 'build_6EN6t3jH',
                bucketId: 'bucket_WosLAtJQ',
                status: 'active',
                additionalArtifacts: [],
                workItemsByBuild: generateWorkItems(),
                binaryBuild: {
                    id: 'build_6EN6t3jH',
                    type: 'ipa',
                    buildNumber: '3867',
                    buildVersion: '3.102.0',
                    provisioningProfile: {
                        id: 'PJ55BNQX2M',
                        name: 'Bitrise iOS app-store - (com.demo)',
                        profileType: 'IOS_APP_STORE',
                        expirationDate: '2023-12-22T23:05:37Z',
                        profileState: 'ACTIVE',
                        certificates: [
                            {
                                name: 'Apple Distribution: demo, LLC',
                                expirationDate: '2023-12-22T23:05:37Z',
                                certificateType: 'DISTRIBUTION',
                            },
                        ],
                        creationDate: '2021-05-05T20:44:20.762661335Z',
                        devices: [],
                        bundleId: 'com.demo',
                    },
                    buildType: 'BuildArtifactIOSAppStore',
                    artifactFileName: 'appollo.ipa',
                },
                ciBuild: {
                    buildHash: 'gmsOQ_w6MEXgchvOIW2NJ14br4g=',
                    buildIdentifier: '3867',
                    integrationId: 'bitrise',
                    buildUrl: 'https://app.bitrise.io/build/2e44fb12-3c63-4726-b8e3-426280d831b8',
                    buildStartedAt: '2023-03-18T01:33:35Z',
                    buildFinishedAt: '2023-03-18T01:38:27Z',
                    buildStatus: 'success',
                    providerBuildStatusString: 'Success',
                    commit: 'fc1c4fdfaa72ee754e910287b339441628eb09e1',
                    commitMessage: 'Refactor code to improve readability',
                    commitAuthor: null,
                    commitUrl: null,
                    workflowName: 'build-app-store',
                    branchName: 'release-3.102.0',
                },
                createdAt: '2023-05-05T20:44:29.608775637Z',
                updatedAt: '2023-05-05T20:44:30.5778224Z',
                individualTesters: [],
                testerNotes: 'Added a confirmation dialog before removing items from the cart.',
                installationUrl:
                    '/api/org/demo/app/appollo-ios/build-distribution/build/build_6EN6t3jH/install?bucketId=bucket_WosLAtJQ',
                uploadedAt: '2023-03-18T01:38:27Z',
                isMultiArtifact: false,
            },
            build_6EN6t3j2: {
                id: 'build_6EN6t3j2',
                bucketId: 'bucket_NT5awios',
                status: 'active',
                additionalArtifacts: [],
                workItemsByBuild: generateWorkItems(),
                binaryBuild: {
                    id: 'build_6EN6t3j2',
                    type: 'ipa',
                    buildNumber: '3867',
                    buildVersion: '3.102.0',
                    provisioningProfile: {
                        id: 'PJ55BNQX2M',
                        name: 'Bitrise iOS app-store - (com.demo)',
                        profileType: 'IOS_APP_STORE',
                        expirationDate: '2023-12-22T23:05:37Z',
                        profileState: 'ACTIVE',
                        certificates: [
                            {
                                name: 'Apple Distribution: demo, LLC',
                                expirationDate: '2023-12-22T23:05:37Z',
                                certificateType: 'DISTRIBUTION',
                            },
                        ],
                        creationDate: '2021-05-05T20:44:20.762661335Z',
                        devices: [],
                        bundleId: 'com.demo',
                    },
                    buildType: 'BuildArtifactIOSAppStore',
                    artifactFileName: 'appollo.ipa',
                },
                ciBuild: {
                    buildHash: 'gmsOQ_w6MEXgchvOIW2NJ14br4g=',
                    buildIdentifier: '3867',
                    integrationId: 'bitrise',
                    buildUrl: 'https://app.bitrise.io/build/2e44fb12-3c63-4726-b8e3-426280d831b8',
                    buildStartedAt: '2023-03-18T01:33:35Z',
                    buildFinishedAt: '2023-03-18T01:38:27Z',
                    buildStatus: 'success',
                    providerBuildStatusString: 'Success',
                    commit: 'fc1c4fdfaa72ee754e910287b339441628eb09e1',
                    commitMessage: 'Refactor code to improve readability',
                    commitAuthor: null,
                    commitUrl: null,
                    workflowName: 'build-app-store',
                    branchName: 'release-3.102.0',
                },
                createdAt: '2023-05-05T20:44:29.608775637Z',
                updatedAt: '2023-05-05T20:44:30.5778224Z',
                individualTesters: [],
                testerNotes: 'Optimized load time for the home screen.',
                installationUrl:
                    '/api/org/demo/app/appollo-ios/build-distribution/build/build_6EN6t3jH/install?bucketId=bucket_WosLAtJQ',
                uploadedAt: '2023-03-18T01:38:27Z',
                isMultiArtifact: false,
            },
            build_qzXtzmUY: {
                id: 'build_qzXtzmUY',
                bucketId: 'bucket_WosLAtJQ',
                status: 'active',
                additionalArtifacts: [],
                workItemsByBuild: generateWorkItems(),
                binaryBuild: {
                    id: 'build_qzXtzmUY',
                    type: 'ipa',
                    buildNumber: '3866',
                    buildVersion: '3.102.0',
                    provisioningProfile: {
                        id: 'PJ55BNQX2M',
                        name: 'Bitrise iOS app-store - (com.demo)',
                        profileType: 'IOS_APP_STORE',
                        expirationDate: '2023-12-22T23:05:37Z',
                        profileState: 'ACTIVE',
                        certificates: [
                            {
                                name: 'Apple Distribution: demo, LLC',
                                expirationDate: '2023-12-22T23:05:37Z',
                                certificateType: 'DISTRIBUTION',
                            },
                        ],
                        creationDate: '2021-05-05T20:44:20.762661335Z',
                        devices: [],
                        bundleId: 'com.demo',
                    },
                    buildType: 'BuildArtifactIOSAppStore',
                    artifactFileName: 'appollo.ipa',
                },
                ciBuild: {
                    buildHash: '3XvAzakOP6nyiQjQFG-TIDRM6fk=',
                    buildIdentifier: '3866',
                    integrationId: 'bitrise',
                    buildUrl: 'https://app.bitrise.io/build/8d09d023-8f24-4ca9-9719-7e22029e5f87',
                    buildStartedAt: '2023-03-18T00:01:43Z',
                    buildFinishedAt: '2023-03-18T00:06:50Z',
                    buildStatus: 'success',
                    providerBuildStatusString: 'Success',
                    commit: 'fc1c4fdfaa72ee754e910287b339441628eb09e1',
                    commitMessage: 'Update UI layout for better user experience',
                    commitAuthor: null,
                    commitUrl: null,
                    workflowName: 'build-app-store',
                    branchName: 'release-3.102.0',
                },
                createdAt: '2023-05-05T20:44:33.462809301Z',
                updatedAt: '2023-05-05T20:44:40.471715636Z',
                individualTesters: [],
                testerNotes: 'Refined search bar responsiveness to quick typing.',
                installationUrl:
                    '/api/org/demo/app/appollo-ios/build-distribution/build/build_qzXtzmUY/install?bucketId=bucket_WosLAtJQ',
                uploadedAt: '2023-03-18T00:06:50Z',
                isMultiArtifact: false,
            },
            build_kVHf3nIv: {
                id: 'build_kVHf3nIv',
                bucketId: 'bucket_WosLAtJQ',
                status: 'active',
                additionalArtifacts: [],
                workItemsByBuild: generateWorkItems(),
                binaryBuild: {
                    id: 'build_fjkOmdPF',
                    type: 'apk',
                    buildNumber: '79900',
                    buildVersion: '1.54.0',
                    provisioningProfile: null,
                    buildType: 'BuildArtifactAndroidReleaseSigned',
                    artifactFileName: 'app-universal-release.apk',
                },
                ciBuild: {
                    buildHash: 'nMGXArA3YFafzijcT82cX5cJkvo=',
                    buildIdentifier: '3853',
                    integrationId: 'bitrise',
                    buildUrl: 'https://app.bitrise.io/build/21fe012e-cb0b-4c36-b047-ff2fa5d02370',
                    buildStartedAt: '2023-03-14T16:12:24Z',
                    buildFinishedAt: '2023-03-14T16:13:16Z',
                    buildStatus: 'success',
                    providerBuildStatusString: 'Success',
                    commit: 'fc1c4fdfaa72ee754e910287b339441628eb09e1',
                    commitMessage: 'Integrate push notification service',
                    commitAuthor: null,
                    commitUrl: null,
                    workflowName: '',
                    branchName: 'release-3.102.0',
                },
                createdAt: '2023-05-16T18:57:26.678426301Z',
                updatedAt: '2023-05-16T18:57:26.678426375Z',
                individualTesters: [],
                testerNotes: 'Enhanced screen reader support on the settings page.',
                installationUrl:
                    '/api/org/demo/app/appollo-ios/build-distribution/build/build_kVHf3nIv/install?bucketId=bucket_WosLAtJQ',
                uploadedAt: '2023-03-14T16:13:16Z',
                isMultiArtifact: false,
            },
            build_PFCcQepd: {
                id: 'build_PFCcQepd',
                bucketId: 'bucket_vR7t1UA2',
                status: 'active',
                additionalArtifacts: [],
                workItemsByBuild: generateWorkItems(),
                binaryBuild: {
                    id: 'build_fjkOmdPF',
                    type: 'apk',
                    buildNumber: '79900',
                    buildVersion: '1.54.0',
                    provisioningProfile: null,
                    buildType: 'BuildArtifactAndroidReleaseSigned',
                    artifactFileName: 'app-universal-release.apk',
                },
                ciBuild: {
                    buildHash: 'owhHIp5gAzNEi4l2XSEGTKCkus0=',
                    buildIdentifier: '794',
                    integrationId: 'bitrise',
                    buildUrl: 'https://app.bitrise.io/build/3f1b2a1f-5984-4b7a-ab0e-9ec8465cdffb',
                    buildStartedAt: '2023-05-10T11:29:35Z',
                    buildFinishedAt: '2023-05-10T11:30:51Z',
                    buildStatus: 'success',
                    providerBuildStatusString: 'Success',
                    commit: '9290eb5e03dd370e450f0588bc033a4b7ef73b32',
                    commitMessage: 'Resolve compatibility issue with latest OS version',
                    commitAuthor: null,
                    commitUrl: null,
                    workflowName: '',
                    branchName: 'master',
                },
                createdAt: '2023-05-10T13:29:39.011791+02:00',
                updatedAt: '2023-05-10T13:29:39.011791+02:00',
                individualTesters: [],
                testerNotes: 'Updated the loading spinner animation.',
                installationUrl:
                    '/api/org/demo/app/appollo-ios/build-distribution/build/build_PFCcQepd/install?bucketId=bucket_vR7t1UA2',
                uploadedAt: '2023-05-10T11:30:51Z',
                isMultiArtifact: false,
            },
            build_PFCcQep2: {
                id: 'build_PFCcQep2',
                bucketId: 'bucket_NT5awsf6',
                status: 'active',
                additionalArtifacts: [],
                workItemsByBuild: generateWorkItems(),
                binaryBuild: {
                    id: 'build_PFCcQep2',
                    type: 'apk',
                    buildNumber: '79900',
                    buildVersion: '1.54.0',
                    provisioningProfile: null,
                    buildType: 'BuildArtifactAndroidReleaseSigned',
                    artifactFileName: 'app-universal-release.apk',
                },
                ciBuild: {
                    buildHash: 'owhHIp5gAzNEi4l2XSEGTKCkus0=',
                    buildIdentifier: '794',
                    integrationId: 'bitrise',
                    buildUrl: 'https://app.bitrise.io/build/3f1b2a1f-5984-4b7a-ab0e-9ec8465cdffb',
                    buildStartedAt: '2023-05-10T11:29:35Z',
                    buildFinishedAt: '2023-05-10T11:30:51Z',
                    buildStatus: 'success',
                    providerBuildStatusString: 'Success',
                    commit: '9290eb5e03dd370e450f0588bc033a4b7ef73b32',
                    commitMessage: 'Resolve compatibility issue with latest OS version',
                    commitAuthor: null,
                    commitUrl: null,
                    workflowName: '',
                    branchName: 'master',
                },
                createdAt: '2023-05-10T13:29:39.011791+02:00',
                updatedAt: '2023-05-10T13:29:39.011791+02:00',
                individualTesters: [],
                testerNotes: 'Refined the transition animation between screens.',
                installationUrl:
                    '/api/org/demo/app/appollo-ios/build-distribution/build/build_PFCcQepd/install?bucketId=bucket_vR7t1UA2',
                uploadedAt: '2023-05-10T11:30:51Z',
                isMultiArtifact: false,
            },
            build_PFCcQep3: {
                id: 'build_PFCcQep3',
                bucketId: 'bucket_NT5awsf6',
                status: 'active',
                additionalArtifacts: [],
                workItemsByBuild: generateWorkItems(),
                binaryBuild: {
                    id: 'build_PFCcQep3',
                    type: 'apk',
                    buildNumber: '79900',
                    buildVersion: '1.54.0',
                    provisioningProfile: null,
                    buildType: 'BuildArtifactAndroidReleaseSigned',
                    artifactFileName: 'app-universal-release.apk',
                },
                ciBuild: {
                    buildHash: 'owhHIp5gAzNEi4l2XSEGTKCkus0=',
                    buildIdentifier: '794',
                    integrationId: 'bitrise',
                    buildUrl: 'https://app.bitrise.io/build/3f1b2a1f-5984-4b7a-ab0e-9ec8465cdffb',
                    buildStartedAt: '2023-05-10T11:29:35Z',
                    buildFinishedAt: '2023-05-10T11:30:51Z',
                    buildStatus: 'success',
                    providerBuildStatusString: 'Success',
                    commit: '9290eb5e03dd370e450f0588bc033a4b7ef73b32',
                    commitMessage: 'Resolve compatibility issue with latest OS version',
                    commitAuthor: null,
                    commitUrl: null,
                    workflowName: '',
                    branchName: 'master',
                },
                createdAt: '2023-05-10T13:29:39.011791+02:00',
                updatedAt: '2023-05-10T13:29:39.011791+02:00',
                individualTesters: [],
                testerNotes: 'Added tooltips for icons in the toolbar.',
                installationUrl:
                    '/api/org/demo/app/appollo-ios/build-distribution/build/build_PFCcQepd/install?bucketId=bucket_vR7t1UA2',
                uploadedAt: '2023-05-10T11:30:51Z',
                isMultiArtifact: false,
            },
            build_EppuDgtT: {
                id: 'build_EppuDgtT',
                bucketId: 'bucket_vR7t1UA2',
                status: 'active',
                additionalArtifacts: [],
                workItemsByBuild: generateWorkItems(),
                binaryBuild: {
                    id: 'build_fjkOmdPF',
                    type: 'apk',
                    buildNumber: '79900',
                    buildVersion: '1.54.0',
                    provisioningProfile: null,
                    buildType: 'BuildArtifactAndroidReleaseSigned',
                    artifactFileName: 'app-universal-release.apk',
                },
                ciBuild: {
                    buildHash: 'MpBYuTHj5YsyxBTht_Dupig-Dkk=',
                    buildIdentifier: '790',
                    integrationId: 'bitrise',
                    buildUrl: 'https://app.bitrise.io/build/362efc51-6ca7-452e-b00a-59c065944df9',
                    buildStartedAt: '2023-05-03T20:48:08Z',
                    buildFinishedAt: '2023-05-03T20:49:24Z',
                    buildStatus: 'success',
                    providerBuildStatusString: 'Success',
                    commit: '9290eb5e03dd370e450f0588bc033a4b7ef73b32',
                    commitMessage: 'Add support for multiple languages',
                    commitAuthor: null,
                    commitUrl: null,
                    workflowName: '',
                    branchName: 'master',
                },
                createdAt: '2023-05-05T18:42:07.876657452Z',
                updatedAt: '2023-05-05T18:42:07.876657538Z',
                individualTesters: [],
                testerNotes: 'Corrected the alignment of text in pop-up dialogs.',
                installationUrl:
                    '/api/org/demo/app/appollo-ios/build-distribution/build/build_EppuDgtT/install?bucketId=bucket_vR7t1UA2',
                uploadedAt: '2023-05-03T20:49:24Z',
                isMultiArtifact: false,
            },
            build_7ugTtvFp: {
                id: 'build_7ugTtvFp',
                bucketId: 'bucket_vR7t1UA2',
                status: 'active',
                additionalArtifacts: [],
                workItemsByBuild: generateWorkItems(),
                binaryBuild: {
                    id: 'build_fjkOmdPF',
                    type: 'apk',
                    buildNumber: '79900',
                    buildVersion: '1.54.0',
                    provisioningProfile: null,
                    buildType: 'BuildArtifactAndroidReleaseSigned',
                    artifactFileName: 'app-universal-release.apk',
                },
                ciBuild: {
                    buildHash: 's1GsuAaqicrjk3tDylp2ffZUvC4=',
                    buildIdentifier: '789',
                    integrationId: 'bitrise',
                    buildUrl: 'https://app.bitrise.io/build/9ace211d-7856-4a76-83db-228ae5266f0a',
                    buildStartedAt: '2023-05-03T20:24:02Z',
                    buildFinishedAt: '2023-05-03T20:25:21Z',
                    buildStatus: 'success',
                    providerBuildStatusString: 'Success',
                    commit: '9290eb5e03dd370e450f0588bc033a4b7ef73b32',
                    commitMessage: 'Fix memory leak in background service',
                    commitAuthor: null,
                    commitUrl: null,
                    workflowName: '',
                    branchName: 'master',
                },
                createdAt: '2023-05-05T18:42:07.96318508Z',
                updatedAt: '2023-05-05T18:42:07.963185168Z',
                individualTesters: [],
                testerNotes: 'Introduced a new sorting option in the search results.',
                installationUrl:
                    '/api/org/demo/app/appollo-ios/build-distribution/build/build_7ugTtvFp/install?bucketId=bucket_vR7t1UA2',
                uploadedAt: '2023-05-03T20:25:21Z',
                isMultiArtifact: false,
            },
            build_hIHxohcS: {
                id: 'build_hIHxohcS',
                bucketId: 'bucket_vR7t1UA2',
                status: 'active',
                additionalArtifacts: [],
                workItemsByBuild: generateWorkItems(),
                binaryBuild: {
                    id: 'build_fjkOmdPF',
                    type: 'apk',
                    buildNumber: '79900',
                    buildVersion: '1.54.0',
                    provisioningProfile: null,
                    buildType: 'BuildArtifactAndroidReleaseSigned',
                    artifactFileName: 'app-universal-release.apk',
                },
                ciBuild: {
                    buildHash: 'UmrhbAV5q_92Zs3NIH8bbrxSpm4=',
                    buildIdentifier: '788',
                    integrationId: 'bitrise',
                    buildUrl: 'https://app.bitrise.io/build/f0d1467b-0f1f-4c69-8fe4-f8e21c3545fd',
                    buildStartedAt: '2023-05-03T20:16:05Z',
                    buildFinishedAt: '2023-05-03T20:17:27Z',
                    buildStatus: 'success',
                    providerBuildStatusString: 'Success',
                    commit: '9290eb5e03dd370e450f0588bc033a4b7ef73b32',
                    commitMessage: 'Implement offline mode for improved functionality',
                    commitAuthor: null,
                    commitUrl: null,
                    workflowName: '',
                    branchName: 'master',
                },
                createdAt: '2023-05-05T18:42:08.0471194Z',
                updatedAt: '2023-05-08T15:12:25.970726+02:00',
                individualTesters: ['keegan@test.com'],
                testerNotes: 'Implemented swipe gestures for navigating between tabs.',
                installationUrl:
                    '/api/org/demo/app/appollo-ios/build-distribution/build/build_hIHxohcS/install?bucketId=bucket_vR7t1UA2',
                uploadedAt: '2023-05-03T20:17:27Z',
                isMultiArtifact: false,
            },
            build_u0tdefID: {
                id: 'build_u0tdefID',
                bucketId: 'bucket_vR7t1UA2',
                status: 'active',
                additionalArtifacts: [],
                workItemsByBuild: generateWorkItems(),
                binaryBuild: {
                    id: 'build_fjkOmdPF',
                    type: 'apk',
                    buildNumber: '79900',
                    buildVersion: '1.54.0',
                    provisioningProfile: null,
                    buildType: 'BuildArtifactAndroidReleaseSigned',
                    artifactFileName: 'app-universal-release.apk',
                },
                ciBuild: {
                    buildHash: 't8BIZ_FsEe8gHM7gZxhDQbdNPas=',
                    buildIdentifier: '787',
                    integrationId: 'bitrise',
                    buildUrl: 'https://app.bitrise.io/build/11c8f280-37e2-4c81-9a35-bdec3b197022',
                    buildStartedAt: '2023-05-01T16:21:58Z',
                    buildFinishedAt: '2023-05-01T16:23:09Z',
                    buildStatus: 'success',
                    providerBuildStatusString: 'Success',
                    commit: '9290eb5e03dd370e450f0588bc033a4b7ef73b32',
                    commitMessage: 'Update third-party libraries to latest versions',
                    commitAuthor: null,
                    commitUrl: null,
                    workflowName: '',
                    branchName: 'master',
                },
                createdAt: '2023-05-05T18:42:08.125154466Z',
                updatedAt: '2023-05-08T15:12:39.625211+02:00',
                individualTesters: ['keegan@test.com'],
                testerNotes: 'Redesigned the settings page for easier navigation.',
                installationUrl:
                    '/api/org/demo/app/appollo-ios/build-distribution/build/build_u0tdefID/install?bucketId=bucket_vR7t1UA2',
                uploadedAt: '2023-05-01T16:23:09Z',
                isMultiArtifact: false,
            },
            build_TPhMC1JA: {
                id: 'build_TPhMC1JA',
                bucketId: 'bucket_mw53JYI0',
                status: 'active',
                additionalArtifacts: [],
                workItemsByBuild: generateWorkItems(),
                binaryBuild: {
                    id: 'build_TPhMC1JA',
                    type: 'apk',
                    buildNumber: '80000',
                    buildVersion: '1.54.0',
                    provisioningProfile: null,
                    buildType: 'BuildArtifactAndroidReleaseSigned',
                    artifactFileName: 'app-universal-release.apk',
                },
                ciBuild: {
                    buildHash: 'pFoT2eBCWWeM-HqFYTpNy7pMngs=',
                    buildIdentifier: '800',
                    integrationId: 'bitrise',
                    buildUrl: 'https://app.bitrise.io/build/83b302db-46c3-446d-a2a8-dc07ecd2dffe',
                    buildStartedAt: '2023-05-18T16:25:55Z',
                    buildFinishedAt: '2023-05-18T16:28:17Z',
                    buildStatus: 'success',
                    providerBuildStatusString: 'Success',
                    commit: '0c069d84548200d409804968fd48f1d55b63d8c4',
                    commitMessage: 'Enhance error handling and logging',
                    commitAuthor: 'ifbarrera',
                    commitUrl:
                        'https://github.com/runway-org/fake-app-android/commit/0c069d84548200d409804968fd48f1d55b63d8c4',
                    workflowName: 'release',
                    branchName: 'release-1.54.0',
                },
                createdAt: '2023-05-18T12:26:00.025568-04:00',
                updatedAt: '2023-05-18T12:29:05.33328-04:00',
                individualTesters: [],
                testerNotes: 'Added multi-language support for the main interface.',
                installationUrl:
                    '/api/org/demo/app/appollo-ios/build-distribution/build/build_TPhMC1JA/install?bucketId=bucket_mw53JYI0',
                uploadedAt: '2023-05-18T16:28:17Z',
                isMultiArtifact: false,
            },
            build_fjkOmdPF: {
                id: 'build_fjkOmdPF',
                bucketId: 'bucket_mw53JYI0',
                status: 'active',
                additionalArtifacts: [],
                workItemsByBuild: generateWorkItems(),
                binaryBuild: {
                    id: 'build_fjkOmdPF',
                    type: 'apk',
                    buildNumber: '79900',
                    buildVersion: '1.54.0',
                    provisioningProfile: null,
                    buildType: 'BuildArtifactAndroidReleaseSigned',
                    artifactFileName: 'app-universal-release.apk',
                },
                ciBuild: {
                    buildHash: 'HA65XINZjcev9rJAYv5ZELY9A8A=',
                    buildIdentifier: '799',
                    integrationId: 'bitrise',
                    buildUrl: 'https://app.bitrise.io/build/c966c0b1-25e5-4379-8ccd-a8a30d94c30d',
                    buildStartedAt: '2023-05-15T19:57:09Z',
                    buildFinishedAt: '2023-05-15T19:59:32Z',
                    buildStatus: 'success',
                    providerBuildStatusString: 'Success',
                    commit: '0c069d84548200d409804968fd48f1d55b63d8c4',
                    commitMessage: 'Add unit tests for critical components',
                    commitAuthor: 'ifbarrera',
                    commitUrl:
                        'https://github.com/runway-org/fake-app-android/commit/0c069d84548200d409804968fd48f1d55b63d8c4',
                    workflowName: 'release',
                    branchName: 'release-1.54.0',
                },
                createdAt: '2023-05-15T19:57:10.691507775Z',
                updatedAt: '2023-05-17T22:21:18.097526+01:00',
                individualTesters: [],
                testerNotes: 'Improved the onboarding tutorial with interactive elements.',
                installationUrl:
                    '/api/org/demo/app/appollo-ios/build-distribution/build/build_fjkOmdPF/install?bucketId=bucket_mw53JYI0',
                uploadedAt: '2023-05-15T19:59:32Z',
                isMultiArtifact: false,
            },
            build_E9EhqL7t: {
                id: 'build_E9EhqL7t',
                bucketId: 'bucket_mw53JYI0',
                status: 'active',
                additionalArtifacts: [],
                workItemsByBuild: generateWorkItems(),
                binaryBuild: {
                    id: 'build_E9EhqL7t',
                    type: 'apk',
                    buildNumber: '79800',
                    buildVersion: '1.54.0',
                    provisioningProfile: null,
                    buildType: 'BuildArtifactAndroidReleaseSigned',
                    artifactFileName: 'app-universal-release.apk',
                },
                ciBuild: {
                    buildHash: '6FGBNStXBeqSTVxKFCYv9Cxvm3o=',
                    buildIdentifier: '798',
                    integrationId: 'bitrise',
                    buildUrl: 'https://app.bitrise.io/build/cc8969ab-db56-4df8-95e9-4e026856f298',
                    buildStartedAt: '2023-05-15T19:25:33Z',
                    buildFinishedAt: '2023-05-15T19:27:31Z',
                    buildStatus: 'success',
                    providerBuildStatusString: 'Success',
                    commit: '0c069d84548200d409804968fd48f1d55b63d8c4',
                    commitMessage: 'Integrate analytics service for user tracking',
                    commitAuthor: 'ifbarrera',
                    commitUrl:
                        'https://github.com/runway-org/fake-app-android/commit/0c069d84548200d409804968fd48f1d55b63d8c4',
                    workflowName: 'release',
                    branchName: 'release-1.54.0',
                },
                createdAt: '2023-05-15T19:25:35.013800823Z',
                updatedAt: '2023-05-15T19:28:17.54941104Z',
                individualTesters: [],
                testerNotes: 'This build should contain the new analytics service.',
                installationUrl:
                    '/api/org/demo/app/appollo-ios/build-distribution/build/build_E9EhqL7t/install?bucketId=bucket_mw53JYI0',
                uploadedAt: '2023-05-15T19:27:31Z',
                isMultiArtifact: false,
            },
            build_p8DOI5HY: {
                id: 'build_p8DOI5HY',
                bucketId: 'bucket_mw53JYI0',
                status: 'active',
                additionalArtifacts: [],
                workItemsByBuild: generateWorkItems(),
                binaryBuild: {
                    id: 'build_p8DOI5HY',
                    type: 'apk',
                    buildNumber: '79700',
                    buildVersion: '1.54.0',
                    provisioningProfile: null,
                    buildType: 'BuildArtifactAndroidReleaseSigned',
                    artifactFileName: 'app-universal-release.apk',
                },
                ciBuild: {
                    buildHash: 'cn2GCrk9tn55o-db9eRP7mTjSFA=',
                    buildIdentifier: '797',
                    integrationId: 'bitrise',
                    buildUrl: 'https://app.bitrise.io/build/46c71e02-393d-4f42-932d-9dfb5e5209c6',
                    buildStartedAt: '2023-05-15T18:17:36Z',
                    buildFinishedAt: '2023-05-15T18:19:51Z',
                    buildStatus: 'success',
                    providerBuildStatusString: 'Success',
                    commit: '0c069d84548200d409804968fd48f1d55b63d8c4',
                    commitMessage: 'Improve battery efficiency by reducing resource usage',
                    commitAuthor: 'ifbarrera',
                    commitUrl:
                        'https://github.com/runway-org/fake-app-android/commit/0c069d84548200d409804968fd48f1d55b63d8c4',
                    workflowName: 'release',
                    branchName: 'release-1.54.0',
                },
                createdAt: '2023-05-15T18:17:37.707048163Z',
                updatedAt: '2023-05-15T18:20:58.621980013Z',
                individualTesters: [],
                testerNotes: 'Enhanced the overall app performance and stability.',
                installationUrl:
                    '/api/org/demo/app/appollo-ios/build-distribution/build/build_p8DOI5HY/install?bucketId=bucket_mw53JYI0',
                uploadedAt: '2023-05-15T18:19:51Z',
                isMultiArtifact: false,
            },
            build_xV5QlwhM: {
                id: 'build_xV5QlwhM',
                bucketId: 'bucket_mw53JYI0',
                status: 'active',
                additionalArtifacts: [],
                workItemsByBuild: generateWorkItems(),
                binaryBuild: {
                    id: 'build_xV5QlwhM',
                    type: 'apk',
                    buildNumber: '79600',
                    buildVersion: '1.54.0',
                    provisioningProfile: null,
                    buildType: 'BuildArtifactAndroidReleaseSigned',
                    artifactFileName: 'app-universal-release.apk',
                },
                ciBuild: {
                    buildHash: 'Z2szFf4wjK1SLGDGG6Zzx5lJAPM=',
                    buildIdentifier: '796',
                    integrationId: 'bitrise',
                    buildUrl: 'https://app.bitrise.io/build/fac206c4-4ea7-4da3-8ae1-78b2c6fc6fc3',
                    buildStartedAt: '2023-05-15T18:00:56Z',
                    buildFinishedAt: '2023-05-15T18:03:14Z',
                    buildStatus: 'success',
                    providerBuildStatusString: 'Success',
                    commit: '0c069d84548200d409804968fd48f1d55b63d8c4',
                    commitMessage: 'Fix issue causing incorrect data syncing',
                    commitAuthor: 'ifbarrera',
                    commitUrl:
                        'https://github.com/runway-org/fake-app-android/commit/0c069d84548200d409804968fd48f1d55b63d8c4',
                    workflowName: 'release',
                    branchName: 'release-1.54.0',
                },
                createdAt: '2023-05-15T18:00:58.11971014Z',
                updatedAt: '2023-05-15T11:06:55.962817-07:00',
                individualTesters: [],
                testerNotes: 'Added new analytics features for user activity tracking.',
                installationUrl:
                    '/api/org/demo/app/appollo-ios/build-distribution/build/build_xV5QlwhM/install?bucketId=bucket_mw53JYI0',
                uploadedAt: '2023-05-15T18:03:14Z',
                isMultiArtifact: false,
            },
        },
        allBuildIds: [
            'build_csAS2bj5',
            'build_UiFZalKE',
            'build_zD4kNXCy',
            'build_6EN6t3jH',
            'build_qzXtzmUY',
            'build_kVHf3nIv',
            'build_PFCcQepd',
            'build_EppuDgtT',
            'build_7ugTtvFp',
            'build_hIHxohcS',
            'build_u0tdefID',
            'build_TPhMC1JA',
            'build_fjkOmdPF',
            'build_E9EhqL7t',
            'build_p8DOI5HY',
            'build_xV5QlwhM',
        ],
        sharedWithMeBuildIdsForAppId: {
            'appollo-ios': ['build_csAS2bj5'],
            'appollo-android': ['build_PFCcQepd'],
        },
        sharedWithMeTotalCountsForAppId: {},
        bucketIdsForAppId: {
            'appollo-ios': ['bucket_WosLAtJQ', 'bucket_vR7t1ios', 'bucket_NT5awios'],
            'appollo-android': ['bucket_vR7t1UA2', 'bucket_mw53JYI0', 'bucket_NT5awsf6'],
        },
        downloadMetricsForBucketId: {
            bucket_WosLAtJQ: { numDownloadsPerBuild: {} },
            bucket_vR7t1ios: { numDownloadsPerBuild: {} },
            bucket_NT5awios: { numDownloadsPerBuild: {} },
            bucket_vR7t1UA2: { numDownloadsPerBuild: {} },
            bucket_mw53JYI0: { numDownloadsPerBuild: {} },
            bucket_NT5awsf6: { numDownloadsPerBuild: {} },
        },
    };

    return rawObject as BuildDistroReducerType;
};
